import { useFilterValuesSearch } from './use-filter-values-search.hook';
import { SearchIndexEnum } from '@vivli/features/search/infrastructure/enum';

export const useFiltersSearch = () => {
    return useFilterValuesSearch({
        index: SearchIndexEnum.Studies
    });
};
